<template>
  <div class="view-stage-wrap">
    <stage-filters
      ref="StageFilters"
      :dashboardData="dashboardData"
      :reset="resetStageFilters"
      @dashFiltersApplied="dashFiltersApplied"
      :loadingDashboard="isLoading"
      @getDashboardWithFilter="filterApplied"
    ></stage-filters>
    <v-row class="stage-top-bar">
      <v-col cols="8">
        <div class="stage-title-wrap">
          <div class="stage-back-btn">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="white"
                  v-bind="attrs"
                  v-on="on"
                  text
                  @click="onClickBack()"
                >
                  <v-icon>las la-arrow-left</v-icon></v-btn>
              </template>
              <span>Go Back</span>
            </v-tooltip>
          </div>
          <div class="stage-title" v-if="dashboardData.stage_details">
            Critical touchpoints/Snapshot/{{dashboardData.stage_details.title}}
          </div>
          <div class="stage-title" v-else>--</div>
        </div>
      </v-col>
      <v-col cols="4" class="text-right pr-7">
        <v-btn
          color="white"
          class="box-container zoom-in"
          @click.stop="toggleFilterDrawer()"
        >
          <i class="las la-filter mr-1"></i>
          <span>Filter</span>
        </v-btn>
        <v-btn
          v-if="isFilterApplied"
          class="box-container zoom-in ml-2"
          @click="resetDashFilters"
        >
          Reset
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="stage-overview">
      <v-col cols="9">
        <participation-analysis
          :dashboardData="dashboardData"
          :loadingDashboard="isLoading"
        ></participation-analysis>
        <driverOverview
          :dashboardData="dashboardData"
          :loadingDashboard="isLoading"
        ></driverOverview>
        <subdriver-overview
          :dashboardData="dashboardData"
          :loadingDashboard="isLoading"
        ></subdriver-overview>
      </v-col>
      <v-col cols="3">
        <participation-report
          :dashboardData="dashboardData"
          :loadingDashboard="isLoading"
        ></participation-report>
        <div class="report-overview-blank">
          <div class="wellness-wrap">
            <div class="wellness-title">Disengaged Employees</div>
            <div class="wellness-body"
              v-if="dashboardData.disengaged_employees_stats
              && dashboardData.disengaged_employees_stats.disenageged_employees_list
              && dashboardData.disengaged_employees_stats.disenageged_employees_list.length > 0"
            >
              <v-list v-if="dashboardData && dashboardData.disengaged_employees_stats">
                <template v-for="(item, index) in dashboardData.disengaged_employees_stats.disenageged_employees_list">
                  <v-divider :key="`${index}divider`" :inset="true"></v-divider>
                  <v-list-item :key="index" @click="viewEmp(item)">
                    <v-list-item-avatar style="overflow: visible;">
                      <div class="star-icon">
                        <v-icon v-if="item.user__user_profile__high_potential_emp">fas fa-star</v-icon>
                      </div>
                      <!-- <div class="emp-profile-image"> -->
                        <img v-if="item.profilePicture" :src="item.profilePicture" :alt="item.display_name">
                        <img v-else :src="getImgUrl('male-avatar')" :alt="item.user__display_name">
                      <!-- </div> -->
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title v-if="item.user__display_name">{{item.user__display_name}}</v-list-item-title>
                      <v-list-item-title v-else>--</v-list-item-title>
                      <v-list-item-subtitle v-if="item.user__email">{{item.user__email}}</v-list-item-subtitle>
                      <v-list-item-subtitle v-else>--</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-list-item-action-text>
                        <span v-if="item.driverAverage">{{item.driverAverage}}</span>
                        <span v-else>0</span>
                      </v-list-item-action-text>
                      <v-icon></v-icon>
                    </v-list-item-action>
                  </v-list-item>
                </template>
              </v-list>
            </div>
            <div v-else class="am-no-data">
              {{noDisengagedText}}
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row class="stage-overview">
      <v-col cols="12" md="12">
        <v-row>
          <v-col cols="12" md="6" lg="6">
            <employeesVibe
              :dashboardData="dashboardData"
              :loadingDashboard="isLoading"
            ></employeesVibe>
          </v-col>
          <v-col cols="12" md="6" lg="6">
            <engagementOvertime
              :dashboardData="dashboardData"
              :loadingDashboard="isLoading"
            ></engagementOvertime>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
// import dayjs from 'dayjs';

import ParticipationAnalysis from './dashboard/participation-analysis';
import DriverOverview from '../dashboard/overview/driver-overview';
import SubdriverOverview from '../dashboard/overview/subdriver-overview';
import ParticipationReport from '../dashboard/overview/participation-report';
import EmployeesVibe from '../dashboard/overview/employees-vibe';
import EngagementOvertime from '../dashboard/overview/engagement-overtime';
import StageFilters from './dashboard/stage-filters';

import { AM_NO_DISENGAGED } from '../../constant';

export default {
  name: 'ViewStage',

  components: {
    StageFilters,
    ParticipationAnalysis,
    DriverOverview,
    SubdriverOverview,
    ParticipationReport,
    EmployeesVibe,
    EngagementOvertime
  },

  data () {
    return {
      dashboardData: {},
      isLoading: true,
      showFilters: false,
      resetStageFilters: false,
      isFilterApplied: false
    };
  },

  beforeMount () {
    this.stageId = this.$route.params.stageId;
  },

  computed: {
    ...mapState({
      user: state => state.user,
      dashboardFilters: state => state.dashboardFilters,
      updateDashboardFilters: state => state.updateDashboardFilters,
      adminUsers (state) {
        const adminUsers = state.companyAdminsList;
        return adminUsers;
      }
    }),
    noDisengagedText () {
      return AM_NO_DISENGAGED;
    }
  },

  mounted () {
    this.getDashboardReport();
  },

  methods: {
    viewEmp (emp) {
      this.$router.push({ path: `/employees/view/${emp.user__user_profile__id}` }).catch(() => {});
    },
    getImgUrl (pet) {
      const images = require.context('@/assets', false, /\.png$/);
      return images(`./${pet}.png`);
    },
    onClickBack () {
      this.$router.push({ path: '/?tab=touchpoints-snapshot' }).catch(() => {});
    },
    getDashboardReport () {
      this.isLoading = true;
      // let queryParams = {
      //   initiated_date_start: this.dateRangeOptions.startDate ? dayjs(this.dateRangeOptions.startDate).format('YYYY-MM-DD') : undefined,
      //   initiated_date_end: this.dateRangeOptions.startDate ? dayjs(this.dateRangeOptions.endDate).format('YYYY-MM-DD') : undefined
      // };
      const filters = Object.assign({}, this.updateDashboardFilters);
      if (filters && filters.filters) {
        // filters.filters have the dynamic filters value
        delete filters.filters;
      }
      const queryParams = {
        fields: 'title,type,description,company,createdAt,createdBy,lastUpdated,overall_mood,engagement_score,disengaged_employees_stats,chat_response_stats,chat_response_trends,user_participation_stats,user_participation_trends,drivers_analysis,sub_drivers_analysis,company_mood_breakdown,monthwise_engagement_vs_mood_trend',
        ...filters
      };
      if (this.updateDashboardFilters && this.updateDashboardFilters.filters) {
        this.$lodash.each(this.updateDashboardFilters.filters, (v, k) => {
          if (v.length > 0) {
            queryParams[`user__profile__${k}__in`] = v.join();
          }
        });
      }
      axios.get(`${process.env.VUE_APP_API_URL}stage/${this.stageId}/details`, {
        params: queryParams
      }).then((response) => {
        if (response.status === 200) {
          this.dashboardData = response.data;
          this.isLoading = false;
        } else {
          this.$store.dispatch('updateSnackbar', {
            color: 'error',
            show: true,
            text: 'Unable to fetch details, Please try again later!'
          });
          throw new Error(response);
        }
      });
    },
    toggleFilterDrawer () {
      this.$refs.StageFilters.showFilterDrawer = true;
    },
    dashFiltersApplied (val) {
      this.isFilterApplied = val;
    },
    filterApplied (val) {
      this.isFilterApplied = val;
      this.getDashboardReport();
    },
    resetDashFilters () {
      this.$store.dispatch('updateDashboardFilters', null);
      this.isFilterApplied = false;
      this.resetStageFilters = true;
      this.getDashboardReport();
    }
  }
};
</script>

<style lang="scss" scoped>
.view-stage-wrap {
  background-color: var(--bg-panel);
  .stage-overview {
    margin: 0;
  }
  .stage-top-bar {
    background: #050550;
    background-image: -webkit-gradient(linear,right top, left top,from(transparent),to(rgba(51,148,255,0.18)));
    .stage-title {
      color: var(--bg);
      display: flex;
      align-items: center;
      font-size: var(--stats-size-1);
    }
    .stage-title-wrap {
      display: flex;
    }
  }
  .report-overview-blank {
    margin: 16px 0 0 0;
    .wellness-wrap {
      height: 20rem;
      overflow: hidden;
      border-radius: 6px;
      background-color: var(--bg);
      box-shadow: 0 4px 20px 1px rgba(0,0,0,.06), 0 1px 4px rgba(0,0,0,.08) !important;
      .wellness-title {
        padding: 16px;
        font-size: var(--content-size);
        color: var(--color-text);
        text-align: left;
        padding-bottom: 0;
      }
      .wellness-body {
        // padding: 16px;
        height: 18rem;
        overflow-y: auto;
        padding-top: 0;
        font-size: 14px;
        text-align: left;
        .star-icon {
          position: absolute;
          top: 4px;
          left: -6px;
          i {
            color: #fdd835 !important;
            font-size: 20px !important;
          }
        }
      }
      .wellness-action {
        text-align: center;
      }
      .am-no-data {
        padding: 16px;
        height: 15rem;
      }
    }
  }
}
</style>
